<template>
	<v-container fluid fill-height>
		<Artigo :mostrar.sync="abrirArtigo" :artigo="artigo"/>
		<Avisos :mostrar="showModalAvisos" :avisos="avisos" @fecharAvisos="close()"/>
		<v-row class="mx-auto">
			<v-col cols="10" class="offset-1 offset-lg-0 col-lg-6">
				<UltimosTextos @abrirTexto="lerArtigo($event)" titulo="Últimos textos publicados" :registros="textos" />
			</v-col>
			<v-col cols="10" class="offset-1 offset-lg-0 col-lg-6">
				<ProximosEventos titulo="Próximos Eventos" :registros="eventos" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { baseApiUrl, showError } from "@/config/global"
	import UltimosTextos from '@/components/home/UltimosTextos'
	import Avisos from '@/components/home/Avisos'
	import ProximosEventos from '@/components/home/ProximosEventos'
	import axios from 'axios'
	import {mapState} from 'vuex'
	import Artigo from '@/components/estudos/ItemEstudo'
	import { userKey } from "@/config/global"
	
	export default{
		name: 'Inicio',
		components: {/*Modal,*/ UltimosTextos, ProximosEventos, Artigo, Avisos},
		computed:{
			... mapState(['buscandoDados', 'user']),
		},
		data(){
			return{
				textos: {},
				eventos: {},
				showModalAvisos: false,
				avisos: {},
				artigo: {},
				abrirArtigo: false,
			}
		},

		methods:{
			
			lerArtigo(artigo){
				this.artigo = artigo
				this.abrirArtigo = true
			},

			buscaEventos(){
				
				const url = `${baseApiUrl}/home/proximosEventos.php?grau=${this.user.outros.grauAtual}&iniciado=${this.user.iniciado}`

				axios(url)
					.then(res => {
						
						this.eventos = res.data.dados.map(txt => {
							return{
								...txt,
							}
						})
						
					})
					.catch({showError})
			},

			chamaModalAvisos(){
				const url = `${baseApiUrl}/Cadastros/avisos/buscaAvisos.php`

				axios(url)
					.then(res => {
						if(res.data.dados.length > 0){
							this.avisos = res.data.dados.map(avs => {
								return {
									...avs
								}
							})

							this.aviso = this.avisos[0]
							this.showModalAvisos = true
						}
					})
					.catch({showError})
			},

			close(){
				this.showModalAvisos = false
			}
		},

		created(){
			
			const json = sessionStorage.getItem(userKey)
			if(json != null){
				if(this.$route.params.abreAvisos){
					this.chamaModalAvisos()
				}
				//this.buscaTextos()
				this.buscaEventos()
			}else{
				this.$router.push({name: 'auth'})
			}
		}
	}

</script>

<style scoped>
	
</style>